export default __webpack_public_path__ + "locales/tr/DeleteProfileEverDialog.json?hash=0dfd32ab39c87d6d0b4dac847f1b6428";